// extracted by mini-css-extract-plugin
export default {"loaderContainer":"style_loaderContainer__Ulm35","spinner":"style_spinner__ytbdM","spin":"style_spin__p9gYY","text":"style_text__jp7Qe","pulse":"style_pulse__hKMcb"};